import React from "react";
import { HiChevronDoubleDown } from "react-icons/hi";
import { Link as Scroll } from "react-scroll";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import "./Blogs.scss";
import BlogCard from "../../components/BlogCard/BlogCard";
import { client } from "../../sanity/client";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../components/Loading/Loading";
import Banner from "../../components/Banner";

const BlogPage = () => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ["allPostsData"],
    queryFn: async () => {
      const query = `*[_type == "post"]{
_id,
title,
slug,
mainImage,
author->{
  name,
  image,
},
description,
publishedAt,
}`;
      const posts = await client.fetch(query);
      // setAllPosts(posts);
      return posts;
    },

    // staleTime: 1000 * 60 * 60 * 24,
    staleTime: 60 * 1000 * 60 * 24,
  });

  if (isLoading) {
    return (
      <section className="blogs">
        <article className="container flex">
          <Loading />
        </article>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="blogs">
        <article className="container flex">
          <h1 className="" style={{ textAlign: "center", fontSize: "2rem" }}>
            Something went wrong💔
          </h1>
        </article>
      </section>
    );
  }

  return (
    <>
      <section className="header-bg section">
        <div className="banner">
          <Banner />
        </div>
        <article className="header-bg__container">
          <div className="header-bg__container-contents">
            <h1 className="">BLOGS</h1>
          </div>

          <Scroll
            to="next-section"
            smooth={true}
            duration={100}
            delay={0}
            offset={100}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="scroll-btn">
              <HiChevronDoubleDown />
              <span>Scroll Down</span>
            </div>
          </Scroll>
        </article>
      </section>

      <section className="blogs section" id="next-section">
        <article className="blogs__container container">
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry gutter="3rem">
              {data?.map((blog) => (
                <BlogCard blog={blog} key={blog._title} />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </article>
      </section>
    </>
  );
};

export default BlogPage;
